import { useLocation } from 'react-router-dom'
import { SITE_URL } from '@/utils/schema'
import { getBreadcrumbTrail } from '@/utils/breadcrumbs'

export default function BreadcrumbJsonLd() {
  const { pathname } = useLocation()
  const trail = getBreadcrumbTrail(pathname)

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: trail.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: `${SITE_URL}${crumb.path === '/' ? '' : crumb.path}`,
    })),
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  )
}